// extracted by mini-css-extract-plugin
export default {"sliderInput":"slider_sliderInput__80Thm"};